import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Switch from "react-switch";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Collapse,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import { makeSelectStyles } from "../../common/selectStyles";
import {
  FiChevronUp,
  FiChevronDown,
  FiCalendar,
  FiUpload,
  FiEdit3,
} from "react-icons/fi";
function EditImpression() {
  const [wait, setWait] = useState(0);
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  const [isCaracteristiquesAccordionOpen, setIsCaracteristiquesAccordionOpen] =
    useState(true);
  const toggleCaracteristiquesAccordion = () => {
    setIsCaracteristiquesAccordionOpen(!isCaracteristiquesAccordionOpen);
  };
  const [isImpressionAccordionOpen, setIsImpressionAccordionOpen] =
    useState(true);
  const toggleImpressionAccordion = () => {
    setIsImpressionAccordionOpen(!isImpressionAccordionOpen);
  };
  const [isFiltresAccordionOpen, setIsFiltresAccordionOpen] = useState(true);
  const toggleFiltresAccordion = () => {
    setIsFiltresAccordionOpen(!isFiltresAccordionOpen);
  };
  const [isChampsImpressionAccordionOpen, setIsChampsImpressionAccordionOpen] =
    useState(true);
  const toggleChampsImpressionAccordion = () => {
    setIsChampsImpressionAccordionOpen(!isChampsImpressionAccordionOpen);
  };
  const styles = makeSelectStyles(layout);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [impressionData, setImpressionData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const urlParams = new URLSearchParams(window.location.search);

  const modele = urlParams.get("modele_id");

  /*************************   publipostage *******************************/
  const [publipostageData, setPublipostageData] = useState({ data: [] });
  const [selectedPublipostage, setSelectedPublipostage] = useState("");
  const handlePublipostageChange = (e) => {
    setSelectedPublipostage(e);
  };
  const getPublipostage = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/publipostages`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setPublipostageData(data);
          if (modele != null) {
            const transformedModele = data.data.map((data) => ({
              label: data.label,
              value: data.id,
            }));

            const selectedModele = transformedModele.find(
              (data) => data.value == modele
            );

            setSelectedModele(selectedModele);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPublipostageOptions = () => {
    return [
      {
        options: publipostageData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  function formatDateToFrench(inputDate) {
    // Crée un objet Date à partir de la date d'entrée
    const date = new Date(inputDate);

    // Extrayez le jour, le mois et l'année de l'objet Date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Les mois sont indexés à partir de zéro, donc ajoutez 1
    const year = date.getFullYear();

    // Formate la date en format français (DD/MM/YYYY)
    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  }

  /************************* Nature investissement *******************************/
  const [natureInvestissementData, setNatureInvestissementData] = useState({
    data: [],
  });
  const [selectedNatureInvestissement, setSelectedNatureInvestissement] =
    useState("");
  const handleNatureInvestissementChange = (e) => {
    setSelectedNatureInvestissement(e);
  };
  const getNatureInvest = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/impressions/natures_investissements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setNatureInvestissementData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderNatureInvestissementOptions = () => {
    return [
      {
        options: natureInvestissementData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END  *******************************/
  /*************************   Produits  *******************************/
  const [produitsData, setproduitsData] = useState({ data: [] });
  const [selectedProduit, setSelectedProduit] = useState("");
  const handleProduitChange = (e) => {
    setSelectedProduit(e);
  };
  const getProduit = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/produits`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((mode) => {
          setproduitsData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderProduitOptions = () => {
    return [
      {
        options: produitsData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END produits *******************************/
  /************************* investissements  *******************************/
  const [selectedInvestissements, setSelectedInvestissements] = useState("");
  const [investissementsData, setInvestissementsData] = useState({ data: [] });
  const handleInvestissementChange = (e) => {
    setSelectedInvestissements(e);
  };

  const getInvestissements = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/investissements`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((investissements) => {
          setInvestissementsData(investissements);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderInvestissementOptions = () => {
    return [
      {
        options: investissementsData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Catégorie *******************************/
  /*************************   PME  *******************************/
  const [pme, setPmeData] = useState({ data: [] });
  const [selectedPme, setSelectedPme] = useState("");
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };
  const getPme = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/pmes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setPmeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmeOptions = () => {
    return [
      {
        options: pme.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PME *******************************/
  /*************************   Réservation   *******************************/
  const [selectedReservation, setSelectedReservation] = useState("");
  const [reservationData, setReservationData] = useState({ data: [] });
  const handleReservationChange = (e) => {
    setSelectedReservation(e);
  };
  const getReservation = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/reservations`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((reservation) => {
          setReservationData(reservation);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderReservationOptions = () => {
    return [
      {
        options: reservationData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Reservation *******************************/
  //****SHOW */
  const [showField, setShowFied] = useState("");
  const getShow = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/impressions/show_fields?publipostage_id=${
          selectedModele?.value || ""
        }&produit_id=${selectedProduit?.value || ""}&pme_id=${
          selectedPme?.value || ""
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((reservation) => {
          setShowFied(reservation);
        });
    } catch (error) {
      console.log(error);
    }
  };

  /*************************   Modele *******************************/
  const [selectedModele, setSelectedModele] = useState("");
  const handleModeleChange = (e) => {
    setSelectedModele(e);
  };

  /*************************   END Modele  *******************************/
  const [selectedChamps1, setSelectedChamps1] = useState("");
  const [selectedChamps2, setSelectedChamps2] = useState("");
  const [selectedChamps3, setSelectedChamps3] = useState("");
  const [selectedChamps4, setSelectedChamps4] = useState("");
  const [selectedChamps5, setSelectedChamps5] = useState("");
  const [selectedChamps6, setSelectedChamps6] = useState("");
  function getFieldValue(champNumber) {
    switch (champNumber) {
      case 1:
        return selectedChamps1;
      case 2:
        return selectedChamps2;
      case 3:
        return selectedChamps3;
      case 4:
        return selectedChamps4;
      case 5:
        return selectedChamps5;
      case 6:
        return selectedChamps6;
      default:
        return null;
    }
  }

  function handleFieldChange(champNumber, value) {
    switch (champNumber) {
      case 1:
        setSelectedChamps1(value);
        break;
      case 2:
        setSelectedChamps2(value);
        break;
      case 3:
        setSelectedChamps3(value);
        break;
      case 4:
        setSelectedChamps4(value);
        break;
      case 5:
        setSelectedChamps5(value);
        break;
      case 6:
        setSelectedChamps6(value);
        break;
      default:
        break;
    }
  }
  const handleChamps1Change = (e) => {
    setSelectedChamps1(e.target.value);
  };

  const handleChamps2Change = (e) => {
    setSelectedChamps2(e.target.value);
  };

  const handleChamps3Change = (e) => {
    setSelectedChamps3(e.target.value);
  };

  const handleChamps4Change = (e) => {
    setSelectedChamps4(e.target.value);
  };

  const handleChamps5Change = (e) => {
    setSelectedChamps5(e.target.value);
  };

  const handleChamps6Change = (e) => {
    setSelectedChamps6(e.target.value);
  };

  /*************************   Date d'engagement et limite *******************************/
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedDateLimite, setSelectedDateLimite] = useState("");

  /*************************   END date d'engagement   *******************************/
  /*************************   Complément  *******************************/
  const [selectedFichier, setSelectedFichier] = useState("");

  const handleFichierChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      const reader = new FileReader();

      reader.onloadend = function () {
        // Convertir les données du fichier en base64
        const fileData = reader.result.split(",")[1]; // Récupérer la partie base64 des données

        // Créer un objet JSON contenant les données du fichier
        const fileObject = {
          name: newFile.name, // Nom du fichier
          type: newFile.type, // Type MIME du fichier
          size: newFile.size, // Taille du fichier
          data: fileData, // Données du fichier encodées en base64
        };
        setSelectedFichier(fileObject);
      };
      reader.readAsDataURL(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  /************************* END Complément   *******************************/

  /******************************* Date de début *******************************************/
  const [selectedDateDeDebut, setSelectedDateDeDebut] = useState("");

  /******************************* END date de début *******************************************/
  /******************************* date de fin *******************************************/
  const [selectedDateDeFin, setSelectedDateDeFin] = useState("");
  /******************************* Valide *******************************************/
  const [selectedValide, setSelectedValide] = useState("");
  const handleValideChange = (e) => {
    setSelectedValide(e);
  };
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Non
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Oui
      </div>
    );
  };
  /******************************* END Valide *******************************************/
  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };

  /******************************* END Mode de règlement *******************************************/
  /******************************* IBAN *******************************************/
  const [selectedIban, setSelectedIban] = useState("");
  const handleIbanChange = (e) => {
    setSelectedIban(e.target.value);
  };
  /******************************* END IBAN *******************************************/
  /******************************* BIC *******************************************/
  const [selectedBic, setSelectedBic] = useState("");
  const handleBicChange = (e) => {
    setSelectedBic(e.target.value);
  };
  /******************************* END BIC *******************************************/
  /******************************* RUM *******************************************/
  const [selectedRum, setSelectedRum] = useState("");
  const handleRumChange = (e) => {
    setSelectedRum(e.target.value);
  };
  /******************************* END RUM *******************************************/

  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    // if (
    //   selectedPartenaire === null &&
    //   selectedStatut === null &&
    //   selectedTaux === null &&
    //   selectedAnnee === null
    // ) {
    //   toast.error("Remplissez les champs obligatoires");
    // } else if (selectedPartenaire === null && selectedStatut === null) {
    //   toast.error("Le statut et le partenaire ne peuvent pas être vide");
    // } else if (selectedTaux === null) {
    //   toast.error("Le taux ne peut pas être vide");
    // } else if (selectedAnnee === null) {
    //   toast.error("L'année ne peut pas être vide");
    // } else if (selectedPartenaire === null) {
    //   toast.error("Le partenaire ne peut pas être vide");
    // } else if (selectedStatut === null) {
    //   toast.error("Le statut ne peut pas être vide");
    // } else {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/impressions`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            impression: {
              id: id,
              date: selectedDate,
              publipostage_id: selectedModele?.value,
              date_de_debut: selectedDateDeDebut,
              date_de_fin: selectedDateDeFin,
              champ_1: selectedChamps1,
              champ_2: selectedChamps2,
              champ_3: selectedChamps3,
              champ_4: selectedChamps4,
              champ_5: selectedChamps5,
              champ_6: selectedChamps6,
              valide: selectedValide,
              fichier: selectedFichier,
              natures_investissement_id: selectedNatureInvestissement?.value,
              pme_id: selectedPme?.value,
              investissement_id: selectedInvestissements?.value,
              produit_id: selectedProduit?.value,
              reservation_id: selectedReservation?.value,
            },
          }),
        }
      );

      if (response.ok) {
        console.log("PATCH request successful");
        const responseData = await response.json();
        navigate(`${backUrl}/impressions/${responseData.id}`);
        // handleNavigate();
      } else {
        console.error("PATCH request failed");
        const responseData = await response.json();

        if (responseData && responseData.impression_validation) {
          // Si le champ "contact_validation" est présent dans la réponse JSON
          const errors = responseData?.impression_validation;

          errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
    // }
  };
  /******************************* END Validation *******************************************/

  useEffect(() => {
    if (!loading) {
      getPublipostage();
      getNatureInvest();
      getPme();
      getProduit();
      getReservation();
      getInvestissements();
    }
  }, [loading]);
  useEffect(() => {
    if (!loading) {
      getShow();
    }
  }, [loading, selectedModele, selectedProduit, selectedPme]);
  console.log(selectedModele);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Impression | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails impression
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/impressions/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Impressions
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          "Nouveau"
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleCaracteristiquesAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Caractéristiques
                                      </span>
                                    </div>
                                    {isCaracteristiquesAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isCaracteristiquesAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {/* Date */}
                                        <div
                                          className="field-item px-2 py-1 mb-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",

                                            position: "relative",
                                            marginBottom: "1px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Date
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              style={{ position: "relative" }}
                                            >
                                              <InputMask
                                                mask="99/99/9999"
                                                value={selectedDate}
                                                className="form-control form-control-sm shadow-sm border-0"
                                                onChange={(e) =>
                                                  setSelectedDate(
                                                    e.target.value
                                                  )
                                                }
                                                style={{
                                                  fontSize: "0.8rem",
                                                  backgroundColor: "#f8f9fa",
                                                  borderRadius: "6px",
                                                  padding: "0.375rem 0.75rem",
                                                  height: "32px",
                                                }}
                                              />
                                              <FiCalendar
                                                size={12}
                                                className="position-absolute text-muted"
                                                style={{
                                                  right: "8px",
                                                  top: "50%",
                                                  transform: "translateY(-50%)",
                                                  pointerEvents: "none",
                                                  opacity: 0.9,
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                        </div>
                                        {/* Modèle */}
                                        <div
                                          className="field-item px-2 py-1 mb-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",

                                            position: "relative",
                                            marginBottom: "1px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Modèle
                                                </span>
                                                <span className="ms-1">:</span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={selectedModele}
                                                onChange={handleModeleChange}
                                                options={renderPublipostageOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(
                                                  selectedModele === null
                                                )}
                                                menuPortalTarget={document.body}
                                              />
                                              {selectedModele === null && (
                                                <div className="invalid-feedback d-block mt-1 small">
                                                  Modèle ne peut pas être vide
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>

                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleImpressionAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Impression
                                      </span>
                                    </div>
                                    {isImpressionAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse isOpen={isImpressionAccordionOpen}>
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {/* Valide */}
                                        <div
                                          className="field-item px-2 py-1 mb-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",

                                            position: "relative",
                                            marginBottom: "1px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Valide
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="d-flex align-items-center">
                                                <Switch
                                                  uncheckedIcon={<Offsymbol />}
                                                  checkedIcon={<OnSymbol />}
                                                  onColor="#555B21"
                                                  onChange={() => {
                                                    setSelectedValide(
                                                      !selectedValide
                                                    );
                                                  }}
                                                  checked={
                                                    selectedValide == 1
                                                      ? true
                                                      : false
                                                  }
                                                  height={24}
                                                  width={48}
                                                  handleDiameter={20}
                                                />
                                                <span
                                                  className="ms-2 small text-muted"
                                                  style={{
                                                    fontSize: "0.75rem",
                                                  }}
                                                ></span>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Fichier */}
                                        <div
                                          className="field-item px-2 py-1 mb-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",

                                            position: "relative",
                                            marginBottom: "1px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Fichier
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              {selectedFichier != null &&
                                                selectedFichier != "" && (
                                                  <a
                                                    href={selectedFichier}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="d-block mb-2 small text-primary"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                    }}
                                                  >
                                                    <i className="bx bx-file me-1"></i>
                                                    Voir le fichier
                                                  </a>
                                                )}
                                              <div className="position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  type="file"
                                                  required
                                                  onChange={handleFichierChange}
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",
                                                  }}
                                                />
                                                <FiUpload
                                                  size={12}
                                                  className="position-absolute text-muted"
                                                  style={{
                                                    right: "8px",
                                                    top: "50%",
                                                    transform:
                                                      "translateY(-50%)",
                                                    pointerEvents: "none",
                                                    opacity: 0.9,
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                              <Col sm="6">
                                <Col>
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En-tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleFiltresAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Filtres
                                        </span>
                                      </div>
                                      {isFiltresAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    <Collapse isOpen={isFiltresAccordionOpen}>
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {/* PME */}
                                          <div
                                            className="field-item px-2 py-1 mb-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft:
                                                "3px solid transparent",

                                              position: "relative",
                                              marginBottom: "1px",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#e3f2fd";
                                              e.currentTarget.style.borderLeftColor =
                                                "#007bff";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "transparent";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    PME
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <Select
                                                  value={selectedPme}
                                                  onChange={handlePmeChange}
                                                  options={renderPmeOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(false)}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                />
                                              </Col>
                                            </Row>
                                          </div>

                                          {/* Investissement (conditionnel) */}
                                          {showField?.displayed_fields?.includes(
                                            "investissement_id"
                                          ) && (
                                            <div
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",

                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Investissement
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <Select
                                                    value={
                                                      selectedInvestissements
                                                    }
                                                    onChange={
                                                      handleInvestissementChange
                                                    }
                                                    options={renderInvestissementOptions()}
                                                    isClearable={true}
                                                    classNamePrefix="select2-selection"
                                                    styles={styles(false)}
                                                    menuPortalTarget={
                                                      document.body
                                                    }
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          )}

                                          {/* Réservation (conditionnel) */}
                                          {showField?.displayed_fields?.includes(
                                            "reservation_id"
                                          ) && (
                                            <div
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",

                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Réservation
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <Select
                                                    value={selectedReservation}
                                                    onChange={
                                                      handleReservationChange
                                                    }
                                                    options={renderReservationOptions()}
                                                    isClearable={true}
                                                    classNamePrefix="select2-selection"
                                                    styles={styles(false)}
                                                    menuPortalTarget={
                                                      document.body
                                                    }
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          )}

                                          {/* Catégorie PME */}
                                          <div
                                            className="field-item px-2 py-1 mb-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft:
                                                "3px solid transparent",

                                              position: "relative",
                                              marginBottom: "1px",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#e3f2fd";
                                              e.currentTarget.style.borderLeftColor =
                                                "#007bff";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "transparent";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Catégorie PME
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <Select
                                                  value={
                                                    selectedNatureInvestissement
                                                  }
                                                  onChange={
                                                    handleNatureInvestissementChange
                                                  }
                                                  options={renderNatureInvestissementOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(false)}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                />
                                              </Col>
                                            </Row>
                                          </div>

                                          {/* Produit */}
                                          <div
                                            className="field-item px-2 py-1 mb-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft:
                                                "3px solid transparent",

                                              position: "relative",
                                              marginBottom: "1px",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#e3f2fd";
                                              e.currentTarget.style.borderLeftColor =
                                                "#007bff";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "transparent";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Produit
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <Select
                                                  value={selectedProduit}
                                                  onChange={handleProduitChange}
                                                  options={renderProduitOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(false)}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                />
                                              </Col>
                                            </Row>
                                          </div>

                                          {/* Date de début */}
                                          <div
                                            className="field-item px-2 py-1 mb-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft:
                                                "3px solid transparent",

                                              position: "relative",
                                              marginBottom: "1px",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#e3f2fd";
                                              e.currentTarget.style.borderLeftColor =
                                                "#007bff";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "transparent";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Date de début
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={8}
                                                style={{
                                                  position: "relative",
                                                }}
                                              >
                                                <InputMask
                                                  mask="99/99/9999"
                                                  value={selectedDateDeDebut}
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  onChange={(dateString) => {
                                                    setSelectedDateDeDebut(
                                                      dateString.target.value
                                                    );
                                                  }}
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",
                                                  }}
                                                />
                                                <FiCalendar
                                                  size={12}
                                                  className="position-absolute text-muted"
                                                  style={{
                                                    right: "8px",
                                                    top: "50%",
                                                    transform:
                                                      "translateY(-50%)",
                                                    pointerEvents: "none",
                                                    opacity: 0.9,
                                                  }}
                                                />
                                              </Col>
                                            </Row>
                                          </div>

                                          {/* Date de fin */}
                                          <div
                                            className="field-item px-2 py-1 mb-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft:
                                                "3px solid transparent",

                                              position: "relative",
                                              marginBottom: "1px",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#e3f2fd";
                                              e.currentTarget.style.borderLeftColor =
                                                "#007bff";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "transparent";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Date de fin
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={8}
                                                style={{
                                                  position: "relative",
                                                }}
                                              >
                                                <InputMask
                                                  mask="99/99/9999"
                                                  value={selectedDateDeFin}
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  onChange={(dateString) => {
                                                    setSelectedDateDeFin(
                                                      dateString.target.value
                                                    );
                                                  }}
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",
                                                  }}
                                                />
                                                <FiCalendar
                                                  size={12}
                                                  className="position-absolute text-muted"
                                                  style={{
                                                    right: "8px",
                                                    top: "50%",
                                                    transform:
                                                      "translateY(-50%)",
                                                    pointerEvents: "none",
                                                    opacity: 0.9,
                                                  }}
                                                />
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>

                                  <Col sm="12">
                                    <Row>
                                      <Col sm="12">
                                        <Row>
                                          <Col sm="12">
                                            <Card
                                              className="shadow-sm border-0 overflow-hidden mb-4"
                                              style={{ borderRadius: "12px" }}
                                            >
                                              {/* En-tête cliquable */}
                                              <div
                                                className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                                style={{
                                                  background: "#555B21",
                                                  letterSpacing: "0.5px",
                                                  cursor: "pointer",
                                                  userSelect: "none",
                                                }}
                                                onClick={
                                                  toggleChampsImpressionAccordion
                                                }
                                              >
                                                <div className="d-flex align-items-center">
                                                  <span
                                                    style={{
                                                      fontSize: "0.82rem",
                                                    }}
                                                  >
                                                    Champs d'impression
                                                  </span>
                                                </div>
                                                {isChampsImpressionAccordionOpen ? (
                                                  <FiChevronUp size={16} />
                                                ) : (
                                                  <FiChevronDown size={16} />
                                                )}
                                              </div>

                                              <Collapse
                                                isOpen={
                                                  isChampsImpressionAccordionOpen
                                                }
                                              >
                                                <CardBody className="p-0">
                                                  <div
                                                    className="fields-container"
                                                    style={{
                                                      paddingBottom: "8px",
                                                    }}
                                                  >
                                                    {/* Champ 1 */}
                                                    {showField?.displayed_fields?.includes(
                                                      "champ_1"
                                                    ) && (
                                                      <div
                                                        className="field-item px-2 py-1 mb-1"
                                                        style={{
                                                          backgroundColor:
                                                            "white",
                                                          transition:
                                                            "all 0.15s ease",
                                                          borderLeft:
                                                            "3px solid transparent",

                                                          position: "relative",
                                                          marginBottom: "1px",
                                                        }}
                                                        onMouseEnter={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#e3f2fd";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#007bff";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "white";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "transparent";
                                                        }}
                                                      >
                                                        <Row className="align-items-center g-1">
                                                          <Col xs={12} md={4}>
                                                            <div className="d-flex align-items-center small text-muted">
                                                              <span
                                                                className="fw-medium"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                  letterSpacing:
                                                                    "0.2px",
                                                                }}
                                                              >
                                                                Champ 1
                                                              </span>
                                                              <span className="ms-1 text-primary">
                                                                :
                                                              </span>
                                                            </div>
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={8}
                                                            style={{
                                                              position:
                                                                "relative",
                                                            }}
                                                          >
                                                            <input
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              value={
                                                                selectedChamps1
                                                              }
                                                              required
                                                              onChange={
                                                                handleChamps1Change
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                height: "32px",
                                                              }}
                                                            />
                                                            <FiEdit3
                                                              size={12}
                                                              className="position-absolute text-muted"
                                                              style={{
                                                                right: "8px",
                                                                top: "50%",
                                                                transform:
                                                                  "translateY(-50%)",
                                                                pointerEvents:
                                                                  "none",
                                                                opacity: 0.9,
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </div>
                                                    )}

                                                    {/* Champ 2 */}
                                                    {showField?.displayed_fields?.includes(
                                                      "champ_2"
                                                    ) && (
                                                      <div
                                                        className="field-item px-2 py-1 mb-1"
                                                        style={{
                                                          backgroundColor:
                                                            "white",
                                                          transition:
                                                            "all 0.15s ease",
                                                          borderLeft:
                                                            "3px solid transparent",

                                                          position: "relative",
                                                          marginBottom: "1px",
                                                        }}
                                                        onMouseEnter={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#e3f2fd";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#007bff";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "white";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "transparent";
                                                        }}
                                                      >
                                                        <Row className="align-items-center g-1">
                                                          <Col xs={12} md={4}>
                                                            <div className="d-flex align-items-center small text-muted">
                                                              <span
                                                                className="fw-medium"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                  letterSpacing:
                                                                    "0.2px",
                                                                }}
                                                              >
                                                                Champ 2
                                                              </span>
                                                              <span className="ms-1 text-primary">
                                                                :
                                                              </span>
                                                            </div>
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={8}
                                                            style={{
                                                              position:
                                                                "relative",
                                                            }}
                                                          >
                                                            <input
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              value={
                                                                selectedChamps2
                                                              }
                                                              required
                                                              onChange={
                                                                handleChamps2Change
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                height: "32px",
                                                              }}
                                                            />
                                                            <FiEdit3
                                                              size={12}
                                                              className="position-absolute text-muted"
                                                              style={{
                                                                right: "8px",
                                                                top: "50%",
                                                                transform:
                                                                  "translateY(-50%)",
                                                                pointerEvents:
                                                                  "none",
                                                                opacity: 0.9,
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </div>
                                                    )}

                                                    {/* Champ 3 */}
                                                    {showField?.displayed_fields?.includes(
                                                      "champ_3"
                                                    ) && (
                                                      <div
                                                        className="field-item px-2 py-1 mb-1"
                                                        style={{
                                                          backgroundColor:
                                                            "white",
                                                          transition:
                                                            "all 0.15s ease",
                                                          borderLeft:
                                                            "3px solid transparent",
                                                          position: "relative",
                                                          marginBottom: "1px",
                                                        }}
                                                        onMouseEnter={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#e3f2fd";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#007bff";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "white";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "transparent";
                                                        }}
                                                      >
                                                        <Row className="align-items-center g-1">
                                                          <Col xs={12} md={4}>
                                                            <div className="d-flex align-items-center small text-muted">
                                                              <span
                                                                className="fw-medium"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                  letterSpacing:
                                                                    "0.2px",
                                                                }}
                                                              >
                                                                Champ 3
                                                              </span>
                                                              <span className="ms-1 text-primary">
                                                                :
                                                              </span>
                                                            </div>
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={8}
                                                            style={{
                                                              position:
                                                                "relative",
                                                            }}
                                                          >
                                                            <input
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              value={
                                                                selectedChamps3
                                                              }
                                                              required
                                                              onChange={
                                                                handleChamps3Change
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                height: "32px",
                                                              }}
                                                            />
                                                            <FiEdit3
                                                              size={12}
                                                              className="position-absolute text-muted"
                                                              style={{
                                                                right: "8px",
                                                                top: "50%",
                                                                transform:
                                                                  "translateY(-50%)",
                                                                pointerEvents:
                                                                  "none",
                                                                opacity: 0.9,
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </div>
                                                    )}

                                                    {/* Champ 4 */}
                                                    {showField?.displayed_fields?.includes(
                                                      "champ_4"
                                                    ) && (
                                                      <div
                                                        className="field-item px-2 py-1 mb-1"
                                                        style={{
                                                          backgroundColor:
                                                            "white",
                                                          transition:
                                                            "all 0.15s ease",
                                                          borderLeft:
                                                            "3px solid transparent",
                                                          position: "relative",
                                                          marginBottom: "1px",
                                                        }}
                                                        onMouseEnter={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#e3f2fd";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#007bff";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "white";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "transparent";
                                                        }}
                                                      >
                                                        <Row className="align-items-center g-1">
                                                          <Col xs={12} md={4}>
                                                            <div className="d-flex align-items-center small text-muted">
                                                              <span
                                                                className="fw-medium"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                  letterSpacing:
                                                                    "0.2px",
                                                                }}
                                                              >
                                                                Champ 4
                                                              </span>
                                                              <span className="ms-1 text-primary">
                                                                :
                                                              </span>
                                                            </div>
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={8}
                                                            style={{
                                                              position:
                                                                "relative",
                                                            }}
                                                          >
                                                            <input
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              value={
                                                                selectedChamps4
                                                              }
                                                              required
                                                              onChange={
                                                                handleChamps4Change
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                height: "32px",
                                                              }}
                                                            />
                                                            <FiEdit3
                                                              size={12}
                                                              className="position-absolute text-muted"
                                                              style={{
                                                                right: "8px",
                                                                top: "50%",
                                                                transform:
                                                                  "translateY(-50%)",
                                                                pointerEvents:
                                                                  "none",
                                                                opacity: 0.9,
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </div>
                                                    )}

                                                    {/* Champ 5 */}
                                                    {showField?.displayed_fields?.includes(
                                                      "champ_5"
                                                    ) && (
                                                      <div
                                                        className="field-item px-2 py-1 mb-1"
                                                        style={{
                                                          backgroundColor:
                                                            "white",
                                                          transition:
                                                            "all 0.15s ease",
                                                          borderLeft:
                                                            "3px solid transparent",
                                                          position: "relative",
                                                          marginBottom: "1px",
                                                        }}
                                                        onMouseEnter={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#e3f2fd";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#007bff";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "white";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "transparent";
                                                        }}
                                                      >
                                                        <Row className="align-items-center g-1">
                                                          <Col xs={12} md={4}>
                                                            <div className="d-flex align-items-center small text-muted">
                                                              <span
                                                                className="fw-medium"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                  letterSpacing:
                                                                    "0.2px",
                                                                }}
                                                              >
                                                                Champ 5
                                                              </span>
                                                              <span className="ms-1 text-primary">
                                                                :
                                                              </span>
                                                            </div>
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={8}
                                                            style={{
                                                              position:
                                                                "relative",
                                                            }}
                                                          >
                                                            <input
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              value={
                                                                selectedChamps5
                                                              }
                                                              required
                                                              onChange={
                                                                handleChamps5Change
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                height: "32px",
                                                              }}
                                                            />
                                                            <FiEdit3
                                                              size={12}
                                                              className="position-absolute text-muted"
                                                              style={{
                                                                right: "8px",
                                                                top: "50%",
                                                                transform:
                                                                  "translateY(-50%)",
                                                                pointerEvents:
                                                                  "none",
                                                                opacity: 0.9,
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </div>
                                                    )}

                                                    {/* Champ 6 */}
                                                    {showField?.displayed_fields?.includes(
                                                      "champ_6"
                                                    ) && (
                                                      <div
                                                        className="field-item px-2 py-1 mb-1"
                                                        style={{
                                                          backgroundColor:
                                                            "white",
                                                          transition:
                                                            "all 0.15s ease",
                                                          borderLeft:
                                                            "3px solid transparent",
                                                          position: "relative",
                                                          marginBottom: "1px",
                                                        }}
                                                        onMouseEnter={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#e3f2fd";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#007bff";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "white";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "transparent";
                                                        }}
                                                      >
                                                        <Row className="align-items-center g-1">
                                                          <Col xs={12} md={4}>
                                                            <div className="d-flex align-items-center small text-muted">
                                                              <span
                                                                className="fw-medium"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                  letterSpacing:
                                                                    "0.2px",
                                                                }}
                                                              >
                                                                Champ 6
                                                              </span>
                                                              <span className="ms-1 text-primary">
                                                                :
                                                              </span>
                                                            </div>
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={8}
                                                            style={{
                                                              position:
                                                                "relative",
                                                            }}
                                                          >
                                                            <input
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              value={
                                                                selectedChamps6
                                                              }
                                                              required
                                                              onChange={
                                                                handleChamps6Change
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                height: "32px",
                                                              }}
                                                            />
                                                            <FiEdit3
                                                              size={12}
                                                              className="position-absolute text-muted"
                                                              style={{
                                                                right: "8px",
                                                                top: "50%",
                                                                transform:
                                                                  "translateY(-50%)",
                                                                pointerEvents:
                                                                  "none",
                                                                opacity: 0.9,
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </div>
                                                    )}
                                                  </div>
                                                </CardBody>
                                              </Collapse>
                                            </Card>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Col>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditImpression;
